import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useState } from "react";
import { ReactSelect, CheckInput, CustomInput } from "../kits/Inputs/Inputs";
export default function OrderOptionCheckList({
  data,
  selected,
  optionAnswerHandler,
  priceType,
  priceHandler,
}) {
  const [errorTxt, setErrorTxt] = useState({ perUnit: "" });
  const arrayContainObject = (array, object) => {
    console.log("test contain", array, object);
    let temp = array.findIndex((a) => a.index == object.index);

    let result;
    if (temp == -1) result = false;
    else result = true;

    return result;
  };
  const selectedItem = (object, parameter) => {
    let result = undefined;
    let temp = selected.filter((v) => v.index == object.index)[0];
    if (temp != undefined) result = temp[parameter];
    console.log(
      "object ***",
      parameter,
      temp != undefined && temp[parameter]
      // object
    );
    return result;
  };
  console.log("test edit parent checklist", data, selected);
  return (
    <>
      {data.params.map((s, i) => {
        return (
          <>
            <div className="d-flex flex-wrap align-items-center ">
              <div className="align-self-end" style={{ width: 130 }}>
                {console.log("data please", data, s)}
                <CheckInput
                  key={`option-${data?.label}-order-key-${i}`}
                  label={s.name}
                  type="checkbox"
                  id={`option-${data?.label}-${i}`}
                  name={`option-${data?.label}`}
                  inputValue={arrayContainObject(selected, s)}
                  onChangeFunc={() => {
                    optionAnswerHandler(s, s.index);
                    console.log("selectOption func on ch");
                  }}
                />
              </div>
              <div className=" flex-grow-1 flex-wrap price-wrapper">
                {" "}
                <div className="price-input">
                  <ReactSelect
                    itemsList={priceType}
                    inputSize="text"
                    title="نوع تاثیر در قیمت واحد"
                    inputValue={priceType.filter(
                      (p) => p.value == selectedItem(s, "unit")
                    )}
                    onChangeFunc={(e) => {
                      console.log("test edit type", e, priceType);
                      priceHandler(s.index, {
                        unit: e.value,
                        pricePerUnit: 0,
                      });
                    }}
                    activate={
                      selected.filter((v) => v.index == s.index)[0] == undefined
                        ? false
                        : true
                    }
                  />
                </div>
                <div className="price-input">
                  {" "}
                  <CustomInput
                    label="تاثیر قیمت در قیمت واحد"
                    inputSize="sm"
                    inputValue={addCommas(selectedItem(s, "pricePerUnit"))}
                    onChangeFunc={(e) => {
                      console.log(
                        "object*** on change",
                        s.index,
                        selected.filter((v) => v.index == s.index)[0]?.unit == 1
                      );
                      if (!isNaN(removeCommas(e.target.value))) {
                        if (
                          selected.filter((v) => v.index == s.index)[0]?.unit ==
                          1
                        ) {
                          console.log("test test 1");
                          if (removeCommas(e.target.value) <= 100) {
                            priceHandler(s.index, {
                              pricePerUnit: removeCommas(e.target.value),
                            });
                            setErrorTxt((prev) => {
                              return {
                                ...prev,
                                [`perUnit-${i}`]: "",
                              };
                            });
                          } else {
                            setErrorTxt((prev) => {
                              return {
                                ...prev,
                                [`perUnit-${i}`]:
                                  "مقدار این عدد باید کمتر از 100 باشد.",
                              };
                            });
                          }
                        } else {
                          console.log("test test 2");
                          priceHandler(s.index, {
                            pricePerUnit: removeCommas(e.target.value),
                          });
                          setErrorTxt((prev) => {
                            return {
                              ...prev,
                              [`perUnit-${i}`]: "",
                            };
                          });
                        }
                      }
                    }}
                    activate={
                      selectedItem(s, "unit") == -1 ||
                      selectedItem(s, "unit") == 0
                        ? "disabled"
                        : selectedItem(s, "status")
                        ? "active"
                        : "disabled"
                    }
                    textErr={errorTxt[`perUnit-${i}`]}
                  />
                </div>
                <div className="price-input">
                  <CustomInput
                    label="تاثیر قیمت در قیمت کل(عدد)"
                    inputSize="text"
                    inputValue={addCommas(selectedItem(s, "priceOnOrder"))}
                    onChangeFunc={(e) =>
                      priceHandler(s.index, {
                        priceOnOrder: removeCommas(e.target.value),
                      })
                    }
                    activate={selectedItem(s, "status") ? "active" : "disabled"}
                  />
                </div>
              </div>
            </div>
            <div className="separator" />
          </>
        );
      })}
    </>
  );
}
